// extracted by mini-css-extract-plugin
module.exports = {"container":"Ff4VjMC5v_Gfgy3UwJvyi"};